import { getQueriesForClient } from '~/app/_repositories/query-service';
import { buildRequest, convertResponseToChatNovelScript } from './common';

export const fetchChatNovelScriptForClient = async ({
  storyId,
  isTrial,
}: {
  storyId: string;
  isTrial: boolean;
}) => {
  const response = await getQueriesForClient(buildRequest(storyId));

  try {
    const chatNovelScript = convertResponseToChatNovelScript(response, isTrial);
    return {
      chatNovelScript,
    };
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};
